/**
 * Quick add from product cards → Dawn cart drawer + cart count.
 */
(function () {
  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  async function refreshCart(itemCount) {
    document.dispatchEvent(
      new CustomEvent('pi:cart-updated', { detail: { item_count: itemCount } }),
    );
    if (typeof window.updateCartCounts === 'function') {
      window.updateCartCounts(itemCount);
    } else {
      document.querySelectorAll('[data-pi-cart-count]').forEach((el) => {
        el.textContent = String(itemCount);
        if (itemCount > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', 'hidden');
      });
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(document.activeElement);
    }
  }

  async function addVariant(variantId, btn) {
    if (!variantId || !window.routes?.cart_add_url) return;
    btn?.setAttribute('aria-busy', 'true');
    btn?.classList.add('is-loading');
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || 'Could not add to cart');
      const cartRes = await fetch(`${window.routes.cart_url || '/cart'}.js`);
      const cart = await cartRes.json();
      await refreshCart(cart.item_count || 0);
    } catch (err) {
      console.warn('[pi-quick-add]', err);
    } finally {
      btn?.removeAttribute('aria-busy');
      btn?.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pi-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addVariant(btn.dataset.variantId, btn);
  });
})();
